/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ct_Upwork_TaglineInputs */

const en_ct_upwork_tagline = /** @type {(inputs: Ct_Upwork_TaglineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Consistent high-quality delivery`)
};

const ar_ct_upwork_tagline = /** @type {(inputs: Ct_Upwork_TaglineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`تسليم عالي الجودة باستمرار`)
};

const bn_ct_upwork_tagline = /** @type {(inputs: Ct_Upwork_TaglineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ধারাবাহিকভাবে উচ্চমানের ডেলিভারি`)
};

const de_ct_upwork_tagline = /** @type {(inputs: Ct_Upwork_TaglineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Konstant hochwertige Lieferung`)
};

const es_ct_upwork_tagline = /** @type {(inputs: Ct_Upwork_TaglineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Entrega constante y de alta calidad`)
};

const fr_ct_upwork_tagline = /** @type {(inputs: Ct_Upwork_TaglineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Une livraison constante et de grande qualité`)
};

const pt_ct_upwork_tagline = /** @type {(inputs: Ct_Upwork_TaglineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Entrega consistente e de alta qualidade`)
};

const zh_ct_upwork_tagline = /** @type {(inputs: Ct_Upwork_TaglineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`一致的高质量交付`)
};

const tr_ct_upwork_tagline = /** @type {(inputs: Ct_Upwork_TaglineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tutarlı, yüksek kaliteli teslimat`)
};

const ru_ct_upwork_tagline = /** @type {(inputs: Ct_Upwork_TaglineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Стабильно высокое качество доставки`)
};

const pl_ct_upwork_tagline = /** @type {(inputs: Ct_Upwork_TaglineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Stała, wysoka jakość dostaw`)
};

/**
* | output |
* | --- |
* | "Consistent high-quality delivery" |
*
* @param {Ct_Upwork_TaglineInputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
export const ct_upwork_tagline = /** @type {((inputs?: Ct_Upwork_TaglineInputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ct_Upwork_TaglineInputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_ct_upwork_tagline(inputs)
	if (locale === "bn") return bn_ct_upwork_tagline(inputs)
	if (locale === "de") return de_ct_upwork_tagline(inputs)
	if (locale === "es") return es_ct_upwork_tagline(inputs)
	if (locale === "fr") return fr_ct_upwork_tagline(inputs)
	if (locale === "pt") return pt_ct_upwork_tagline(inputs)
	if (locale === "zh") return zh_ct_upwork_tagline(inputs)
	if (locale === "tr") return tr_ct_upwork_tagline(inputs)
	if (locale === "ru") return ru_ct_upwork_tagline(inputs)
	if (locale === "pl") return pl_ct_upwork_tagline(inputs)
	return en_ct_upwork_tagline(inputs)
});